export const SIGN_UP_API = 'http://localhost:80/iam/oauth2/sign_up'
export const SIGN_IN_API = 'http://localhost:80/iam/oauth2/sign_in'
export const apiUrl = 'http://localhost:80/content'
export const productsApiUrl = 'https://api.talabatn.net/marketplace'
export const filesUrl = 'https://file.talabatn.net'
export const publicUrl = process.env.PUBLIC_URL + '/'